import Component from '../../common/Component';
export default class Footer extends Component {
  view() {
    return null;
  }
}
flarum.reg.add('core', 'forum/components/Footer', Footer);